import { ThemeProvider, theme } from 'legion-ui';
import Overview from "../../../../src/components/Overview.component.js";
import { overviewFoundation } from "../../../../src/components/constant";
import * as React from 'react';
export default {
  ThemeProvider,
  theme,
  Overview,
  overviewFoundation,
  React
};